

export const aggregateUpdatedAction = (id, version) => ({ type: 'SignalR_AggregateUpdated', payload: { id, version } })
export const connectedAction = (id) => ({ type: 'SignalR_Connected', payload: id })
export const setStatusAction = (status) => ({ type: 'SignalR_StatusUpdate', payload: status })
export const connectedFailedAction = (error) => ({ type: 'SignalR_ConnectionError', payload: error })

